export default __webpack_public_path__ + "static/media/art-pro-slt-poster-2.abda30de.jpg";